
import { useParams } from 'react-router-dom';
import { ProvinciasFormState } from '../../../context/provincias/ProvinciasFormState';
import { Form } from './form';

export const ProvinciasFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Provincia":"Crear Provincia";

  return (
    <ProvinciasFormState>
        <br />
        <Form title={title} />
    </ProvinciasFormState>
  );
};
